import { init } from "next-firebase-auth";

const initAuth = () => {
  init({
    authPageURL: "/login",
    appPageURL: "/dashboard/products",
    loginAPIEndpoint: "/api/login", // required
    logoutAPIEndpoint: "/api/logout", // required
    // @ts-ignore
    firebaseAdminInitConfig: {
      credential: {
        projectId: "simple-eb907",
        clientEmail:
          "firebase-adminsdk-8yjby@simple-eb907.iam.gserviceaccount.com",
        // The private key must not be accessible on the client side.
        privateKey: process.env.DONT_PARSE_FIREBASE_KEY
          ? process.env.FIREBASE_PRIVATE_KEY
          : process.env.FIREBASE_PRIVATE_KEY
          ? JSON.parse(process.env.FIREBASE_PRIVATE_KEY)
          : undefined,
      },
    },
    firebaseClientInitConfig: {
      apiKey: "AIzaSyCIRHc1HnaHHZarrmNNkjJYovam2B33kXE",
      authDomain: "simple-eb907.firebaseapp.com",
      projectId: "simple-eb907",
    },
    cookies: {
      name: "login-simple-menu", // required
      // Keys are required unless you set `signed` to `false`.
      // The keys cannot be accessible on the client side.
      keys: [
        process.env.COOKIE_SECRET_CURRENT,
        process.env.COOKIE_SECRET_PREVIOUS,
      ],
      httpOnly: true,
      maxAge: 12 * 60 * 60 * 24 * 1000, // twelve days
      overwrite: true,
      path: "/",
      sameSite: "strict",
      secure: true, // set this to false in local (non-HTTPS) development
      signed: true,
    },
  });
};
export default initAuth;
